import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Link, MenuItem, Select, TextField, Typography, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { paths } from "frontend/src/pages/paths";
import { CircleLogo } from "frontend/src/ui/circle-logo";
import { MultilineHelperText } from "frontend/src/ui/multiline-helper-text";
import { GuestUserLayout } from "frontend/src/pages/layouts/guest-user-layout";
import { Role } from "frontend/src/shared/types/role";
import { usePageModel } from "./model";
var Copyright = function () { return (React.createElement(Typography, { variant: "body2", color: "textSecondary", align: "center" },
    "Copyright © ",
    React.createElement(Link, { color: "inherit", href: "https://imstream.net/" }, "imstream"),
    " ",
    new Date().getFullYear(),
    ".")); };
var useStyles = makeStyles(function (theme) { return ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}); });
export var Page = function () {
    var _a, _b;
    var classes = useStyles();
    var _c = usePageModel(), email = _c.email, password = _c.password, role = _c.role, submit = _c.submit, isSubmitting = _c.isSubmitting, errors = _c.errors;
    var t = useTranslation("guest").t;
    return (React.createElement(Box, null,
        React.createElement("div", { className: classes.paper },
            React.createElement(CircleLogo, { className: classes.avatar }),
            React.createElement(Typography, { component: "h1", variant: "h5" }, t("pages.register.header")),
            React.createElement("form", { className: classes.form, noValidate: true, onSubmit: submit },
                React.createElement(TextField, { variant: "outlined", margin: "normal", required: true, fullWidth: true, id: "login", autoComplete: "username", label: t("pages.register.email"), autoFocus: true, disabled: isSubmitting, error: Boolean(errors.email), helperText: React.createElement(MultilineHelperText, { texts: (_a = errors.email) !== null && _a !== void 0 ? _a : [] }), value: email.value, onChange: email.onChange }),
                React.createElement(TextField, { variant: "outlined", margin: "normal", required: true, fullWidth: true, label: t("pages.register.password"), type: "password", id: "password", autoComplete: "current-password", disabled: isSubmitting, error: Boolean(errors.password), helperText: React.createElement(MultilineHelperText, { texts: (_b = errors.password) !== null && _b !== void 0 ? _b : [] }), value: password.value, onChange: password.onChange }),
                React.createElement(Box, { mt: 2 },
                    React.createElement(Select, { variant: "outlined", value: role.value, onChange: role.onChange, fullWidth: true },
                        React.createElement(MenuItem, { value: Role.BusinessOwner }, t("pages.register.client")),
                        React.createElement(MenuItem, { value: Role.Rightholder }, t("pages.register.rightholder")))),
                React.createElement(ButtonLoader, { isLoading: isSubmitting, type: "submit", fullWidth: true, variant: "contained", color: "primary", className: classes.submit }, t("pages.register.submit"))),
            React.createElement(Box, { ml: "auto" },
                React.createElement(Link, { component: RouterLink, to: paths.login(), variant: "body2" }, t("pages.register.alreadyRegistered")))),
        React.createElement(Box, { mt: 4 },
            React.createElement(Copyright, null))));
};
export var RegisterPage = function () { return (React.createElement(GuestUserLayout, null,
    React.createElement(Page, null))); };
